import React from 'react';
import BackButton from './backButton';

const BackwaterValveInstallation = () => {
    return (
        <div className="container mx-auto p-4 pt-28">
            <h1 className="text-3xl font-semibold mb-4">Backwater Valve Installation</h1>

            <BackButton />

            <p>
                Is your property susceptible to sewer backups or water damage during heavy rainfall? Our expertise lies in backwater valve installation, a crucial solution to prevent sewage from flowing back into your property and causing damage.
            </p>

            <div className="flex justify-center p-4">
                <div className="w-1/2 flex g-10">
                    <img src="/images/services/backwater-valve/diagram-backwater-valve-flow-kitchener-waterloo.webp" alt="Backwater Valve Installation" className="w-1/2 rounded-lg shadow-lg" />
                    <img src="/images/services/backwater-valve/backflow-valve.png" alt="Backwater Valve Installation" className="w-1/2 rounded-lg shadow-lg" />
                </div>
            </div>

            <p>
                A backwater valve is a vital component that helps protect your property from sewage backup. It is installed in the main sewer line and allows sewage to flow out but prevents it from flowing back into your property. This proactive measure is especially important in areas prone to heavy rainfall or sewer system overloads.
            </p>
            <br />

            <p>
                The installation of a backwater valve offers several benefits, including:
            </p>


            <ul className="list-disc pl-8">
                <li>Preventing sewage backups during heavy rain or flooding.</li>
                <li>Protecting your property from water damage and potential health hazards.</li>
                <li>Complying with local building codes and regulations.</li>
                <li>Increasing the overall resilience of your plumbing system.</li>
            </ul>

            <br />
            <p>
                Our professionals specialize in efficient backwater valve installation, ensuring that your property remains safeguarded against potential sewer-related issues. Whether you're looking to upgrade your existing system or need a new installation, we provide expert services tailored to your specific needs.
            </p>

            <div className="flex justify-center p-4">
                <div className="w-1/2 flex gap-10">
                    <img src="/images/services/backwater-valve/backwater-valve-750.webp" alt="Backwater Valve" className="w-1/2 rounded-lg shadow-lg" />
                    <img src="/images/services/backwater-valve/backwater-valve-clear-cover.webp" alt="Backwater Valve" className="w-1/2 rounded-lg shadow-lg" />
                </div>
            </div>

            <p>
                Don't wait until you experience a sewer backup. Take preventive action by investing in professional backwater valve installation. Contact us for reliable service and ensure the protection of your property from potential water damage and sewer-related issues.
            </p>

        </div>
    );
};

export default BackwaterValveInstallation;
